__turbopack_context__.v({
  "beige": "mortgageSlices-module-scss-module__UYURLW__beige",
  "bulletList": "mortgageSlices-module-scss-module__UYURLW__bulletList",
  "buttonIcon": "mortgageSlices-module-scss-module__UYURLW__buttonIcon",
  "description": "mortgageSlices-module-scss-module__UYURLW__description",
  "disclamer": "mortgageSlices-module-scss-module__UYURLW__disclamer",
  "displayTextButtons": "mortgageSlices-module-scss-module__UYURLW__displayTextButtons",
  "greenSummaryImage": "mortgageSlices-module-scss-module__UYURLW__greenSummaryImage",
  "heroCTA": "mortgageSlices-module-scss-module__UYURLW__heroCTA",
  "heroCTAButtons": "mortgageSlices-module-scss-module__UYURLW__heroCTAButtons",
  "heroCTALeft": "mortgageSlices-module-scss-module__UYURLW__heroCTALeft",
  "heroCTARight": "mortgageSlices-module-scss-module__UYURLW__heroCTARight",
  "hideImageMobile": "mortgageSlices-module-scss-module__UYURLW__hideImageMobile",
  "iconTitleWrapper": "mortgageSlices-module-scss-module__UYURLW__iconTitleWrapper",
  "redSummaryImage": "mortgageSlices-module-scss-module__UYURLW__redSummaryImage",
  "subpage": "mortgageSlices-module-scss-module__UYURLW__subpage",
  "summaryImage": "mortgageSlices-module-scss-module__UYURLW__summaryImage",
  "twoPaths": "mortgageSlices-module-scss-module__UYURLW__twoPaths",
  "twoPathsLeft": "mortgageSlices-module-scss-module__UYURLW__twoPathsLeft",
  "twoPathsRight": "mortgageSlices-module-scss-module__UYURLW__twoPathsRight",
  "twoPathsSubtitle": "mortgageSlices-module-scss-module__UYURLW__twoPathsSubtitle",
});
